module.exports = __webpack_public_path__ + "static/media/Enscape_2022-10-14-22-00-19.15e7454e.jpg";